import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function apiMarkNotificationsAsInteracted() {
  const url = occUrl("/notifications/interact-with-notifications");

  const response = await occFetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });

  return await response.json();
}
